module.exports = __webpack_public_path__ + "static/media/detail-info.ae103a49.png";